import { render } from "./PresentationSectionSmallerImage.vue?vue&type=template&id=4c549a1e&scoped=true"
import script from "./PresentationSectionSmallerImage.vue?vue&type=script&lang=js"
export * from "./PresentationSectionSmallerImage.vue?vue&type=script&lang=js"

import "./PresentationSectionSmallerImage.vue?vue&type=style&index=0&id=4c549a1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c549a1e"]])

export default __exports__